<template>
  <div class="login-title">{{ t('Confirm Registration') }}</div>
  <register-step :step="2" :count="3" />

  <div class="register-form__content">
    <div class="ma-3 no-margin">
      <div v-if="resendSuccess">
        <p>{{ t('Email with confirmation link was resent.') }}</p>
        <p>
          {{ t('Check your spam') }}
          {{ t('or') }}
          <a @click="openLiveSupport">{{ t('contact our live support') }}</a
          >.
        </p>
      </div>
      <div v-else>
        <p>
          {{ t('A confirmation has been forwarded to your email') }}
          <b>{{ userEmail }}</b>
        </p>
        <p>
          {{ t('Click the link in the email to continue the registration process.') }}
        </p>
        <p>
          {{ t("Didn't receive the email?") }}<br />
          <a @click="apiSubmit">{{ t('Send it again') }}</a>
          {{ t('or') }}
          <a @click="openLiveSupport" class="text-lowercase">{{
            t('contact support')
          }}</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import RegisterStep from '@/views/pages/components/register-step.vue';
import { useIntercom, useI18n } from '@/composables';
import { useStore } from '@/store';
import { resendVerificationEmailApiRequest } from '@/services/api/auth/auth-register-api';

const { t } = useI18n();
const store = useStore();
const { openLiveSupport } = useIntercom();

const apiLoading = ref(false);
const resendSuccess = ref(false);

const userEmail = computed(() => store.user?.email);

const apiSubmit = async () => {
  apiLoading.value = true;
  try {
    await resendVerificationEmailApiRequest();
    resendSuccess.value = true;
  } finally {
    apiLoading.value = false;
  }
};
</script>

